import { useEffect, useRef } from "react";

// merchantId issued to vip77.store (ИП) after Yandex Split-Pay approval.
const MERCHANT_ID = "40433079-69c8-4a63-a05f-95d89886e267";

let sdkPromise = null;
function loadYandexPaySdk() {
  if (window.YaPay) return Promise.resolve(window.YaPay);
  if (!sdkPromise) {
    sdkPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://pay.yandex.ru/sdk/v1/pay.js";
      script.async = true;
      script.onload = () => resolve(window.YaPay);
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  return sdkPromise;
}

// Split/BNPL badge amount is quoted at the store's non-cash price, same as
// cordstore.ru: cash price is a discount off this, confirmed across 8 of
// their live listings (all ratio to cash price = 1.195, no variance).
const SPLIT_PRICE_MULTIPLIER = 1.195;

// Renders the official Yandex Pay "pay in installments" badge. `amount` must
// be the site's cash price - this component applies the non-cash markup
// itself so every call site stays consistent.
export default function YandexPayBadge({
  amount,
  className = "",
  size = "m",
  variant = "detailed",
  color = "primary",
  align,
}) {
  const ref = useRef(null);
  const splitAmount = amount ? Math.round(amount * SPLIT_PRICE_MULTIPLIER * 100) / 100 : 0;

  useEffect(() => {
    if (!splitAmount || splitAmount <= 0) return;
    let cancelled = false;
    let unmount = null;

    loadYandexPaySdk().then((YaPay) => {
      if (cancelled || !YaPay || !ref.current) return;
      ref.current.innerHTML = "";
      const instance = YaPay.mountBadge(ref.current, {
        type: "bnpl",
        amount: String(splitAmount),
        size,
        variant,
        color,
        theme: "light",
        ...(align ? { align } : {}),
        merchantId: MERCHANT_ID,
      });
      if (instance && typeof instance.unmount === "function") {
        unmount = () => instance.unmount();
      }
    }).catch(() => {});

    return () => {
      cancelled = true;
      if (unmount) unmount();
    };
  }, [splitAmount, size, variant, color, align]);

  if (!splitAmount || splitAmount <= 0) return null;
  return <div ref={ref} data-testid="yandex-pay-badge" className={className} />;
}
